export const filenameFromUrl = (url, fallback = "report.pdf") => {
  try {
    const name = new URL(url).pathname.split("/").pop();
    return name ? decodeURIComponent(name) : fallback;
  } catch {
    return fallback;
  }
};

export const downloadFileFromUrl = async (url, filename = filenameFromUrl(url)) => {
  if (!url) {
    throw new Error("Missing download link");
  }
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.style.display = "none";
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
};
